export default __webpack_public_path__ + "static/media/etranslator-mobile-1.8622ef7a.png";